import Vue from 'vue'
import App from './App.vue'
import VueSplit from 'vue-split-panel'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

import 'codemirror/lib/codemirror.css'
import 'codemirror-colorpicker/dist/codemirror-colorpicker.css'
import 'codemirror-colorpicker' 

Vue.config.productionTip = false
Vue.use(VueSplit)

new Vue({
  render: h => h(App),
}).$mount('#app')
